import i18n from 'i18n';
import { SHOP_MAP } from './shop';
import LOCALS from 'commons/locals';
import { ORDER_CREATE_SOURCE_MAP } from './order-create-source';

const RAW_MEMBER_CREATE_SOURCE_MAP = {
  WEBSITE: ORDER_CREATE_SOURCE_MAP.WEBSITE,
  GINZA: SHOP_MAP.GINZA,
  HONGKONG: SHOP_MAP.HONGKONG,
  SINGAPORE: SHOP_MAP.SINGAPORE,
  APP: ORDER_CREATE_SOURCE_MAP.APP,
  SHANG_HAI: SHOP_MAP.SHANG_HAI,
  UMEDA: SHOP_MAP.UMEDA,
  SINGAPORE_ASU_GST: SHOP_MAP.SINGAPORE_ASU_GST,
  SINGAPORE_GX: SHOP_MAP.SINGAPORE_GX,
  DUBAI: SHOP_MAP.DUBAI,
  FRANCE: SHOP_MAP.FRANCE,
  NEW_YORK: SHOP_MAP.NEW_YORK,
} as const;

type MemberCreateSource =
  (typeof RAW_MEMBER_CREATE_SOURCE_MAP)[keyof typeof RAW_MEMBER_CREATE_SOURCE_MAP];

const isValidMemberCreateSource = (
  createSource: number,
): createSource is MemberCreateSource => {
  return Object.values(RAW_MEMBER_CREATE_SOURCE_MAP).includes(
    createSource as MemberCreateSource,
  );
};

export const MEMBER_CREATE_SOURCE_MAP = new Proxy(
  RAW_MEMBER_CREATE_SOURCE_MAP,
  {
    ownKeys() {
      throw new Error(
        '❌ 禁止遍历 MEMBER_CREATE_SOURCE_MAP！请直接通过属性精准获取值，如 MEMBER_CREATE_SOURCE_MAP.WEBSITE',
      );
    },
  },
);

const RAW_MEMBER_CREATE_SOURCE_CONFIG_MAP: Record<
  MemberCreateSource,
  { label: string }
> = {
  [RAW_MEMBER_CREATE_SOURCE_MAP.WEBSITE]: {
    label: i18n.t(LOCALS.website),
  },
  [RAW_MEMBER_CREATE_SOURCE_MAP.GINZA]: {
    label: i18n.t(LOCALS.ginza_shop),
  },
  [RAW_MEMBER_CREATE_SOURCE_MAP.HONGKONG]: {
    label: i18n.t(LOCALS.hongkong_shop),
  },
  [RAW_MEMBER_CREATE_SOURCE_MAP.SINGAPORE]: {
    label: i18n.t(LOCALS.singapore_shop),
  },
  [RAW_MEMBER_CREATE_SOURCE_MAP.SINGAPORE_ASU_GST]: {
    label: i18n.t(LOCALS.singapore_shop_asu_gst),
  },
  [RAW_MEMBER_CREATE_SOURCE_MAP.SINGAPORE_GX]: {
    label: i18n.t(LOCALS.kkIwEnEVml),
  },
  [RAW_MEMBER_CREATE_SOURCE_MAP.UMEDA]: {
    label: i18n.t(LOCALS.umeda_store),
  },
  [RAW_MEMBER_CREATE_SOURCE_MAP.SHANG_HAI]: {
    label: i18n.t(LOCALS.shanghai_store),
  },
  [RAW_MEMBER_CREATE_SOURCE_MAP.DUBAI]: {
    label: i18n.t(LOCALS.dubai_store),
  },
  [RAW_MEMBER_CREATE_SOURCE_MAP.FRANCE]: {
    label: i18n.t(LOCALS.france_store),
  },
  [RAW_MEMBER_CREATE_SOURCE_MAP.NEW_YORK]: {
    label: i18n.t(LOCALS.new_york_store),
  },
  [RAW_MEMBER_CREATE_SOURCE_MAP.APP]: {
    label: 'APP',
  },
};

const MEMBER_CREATE_SOURCE_CONFIG_MAP = new Proxy(
  RAW_MEMBER_CREATE_SOURCE_CONFIG_MAP,
  {
    ownKeys() {
      throw new Error(
        '❌ 禁止遍历 MEMBER_CREATE_SOURCE_CONFIG_MAP！请直接通过属性精准获取值',
      );
    },
  },
);

export const getMemberCreateSourceConfig = (createSource: number) => {
  if (!isValidMemberCreateSource(createSource)) {
    throw new Error(`Invalid member createSource: ${createSource}`);
  }

  return MEMBER_CREATE_SOURCE_CONFIG_MAP[createSource];
};

export const MEMBER_CREATE_SOURCE_OPTION_LIST = Object.values(
  RAW_MEMBER_CREATE_SOURCE_MAP,
).map((createSource) => {
  return {
    value: createSource,
    label: getMemberCreateSourceConfig(createSource).label,
  };
});
